/* unplugin-vue-components disabled */import script from "./Comprehensive.vue?vue&type=script&setup=true&lang=js"
export * from "./Comprehensive.vue?vue&type=script&setup=true&lang=js"

import "./Comprehensive.vue?vue&type=style&index=0&id=806e82b8&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-806e82b8"]])

export default __exports__